import c from 'classnames'
import gql from 'graphql-tag'
import React, { useCallback } from 'react'
import Placeholder from '@/components/common/placeholder'
import { useGlobalContext } from '@/components/context'
import buttonStyle from '@sass/common/button.module.sass'
import generalStyle from '@sass/common/general.module.sass'
import { usePublicFormListQuery } from './__gen'
import style from './index.module.sass'
import { PublicForm } from './public-form'

gql`
	query publicFormList($module: ID, $team: ID, $offset: Int) {
		publicForm_List(
			module: $module
			team: $team
			limit: 7
			offset: $offset
			orderBy: [{ field: created, direction: DESC }]
		) {
			objects {
				id
				record {
					id
					name
				}
				createdBy {
					id
					firstName
				}
				form {
					id
					title
				}
				created
			}
			pageInfo {
				hasNextPage
				total
			}
		}
	}
`

const LOADING_PLACEHOLDER = [...Array(5).keys()].map((i) => (
	<Placeholder key={i} style={{ width: 600, height: 40, margin: 10 }} />
))

export const ActiveExternalLinks = () => {
	const { currentModule, currentTeam } = useGlobalContext()
	const variables = {
		module: currentModule.id,
		team: currentTeam ? currentTeam.id : null,
		offset: 0,
	}
	const { data, loading, error, fetchMore } = usePublicFormListQuery({
		variables,
	})

	const more = useCallback(() => {
		const list = data?.publicForm_List
		if (!list) {
			return
		}
		fetchMore({
			variables: {
				...variables,
				offset: list.objects.length,
			},
			updateQuery: (prev, data) => {
				const { fetchMoreResult } = data
				if (!fetchMoreResult) return prev
				return {
					...prev,
					publicForm_List: {
						__typename: 'PublicFormTypeListBase',
						...prev.publicForm_List,
						objects: [...prev!.publicForm_List!.objects, ...fetchMoreResult!.publicForm_List!.objects],
						pageInfo: fetchMoreResult!.publicForm_List!.pageInfo,
					},
				}
			},
		})
	}, [data])

	let inner = null

	if (error) {
		inner = <div className={generalStyle.muted}>Error fetching external links</div>
	} else if (data?.publicForm_List?.objects.length === 0) {
		inner = <div className={generalStyle.muted}>No active external links</div>
	} else if (!data?.publicForm_List) {
		inner = null
	} else {
		inner = data.publicForm_List.objects.map((pf) => <PublicForm key={pf.id} publicForm={pf} />)
	}

	return (
		<div className={style.container}>
			<h5>Active Share Links</h5>
			{inner}
			{loading && LOADING_PLACEHOLDER}
			<div className={style.loadMoreButtonContainer}>
				{data?.publicForm_List?.pageInfo?.hasNextPage && (
					<button className={c(buttonStyle.greySolid, buttonStyle.small)} onClick={more}>
						Load More
					</button>
				)}
			</div>
		</div>
	)
}
